
import { Button , message } from "antd";
import React  from "react";
import { getScheduleTripCityAction, recreateScheduleCities } from "../../actions/admin.action";
import { loadingAction } from "../../actions/loading-actions";
import { setTripCityCreated, setTripData } from "../../actions/trip-create.actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch } from "react-redux";
import { showConfirm } from "../custom-components/custom-component";


export const EditTripComponent =(props)=>{

    const {
        scheduleId,
        recreationRequired = true
    } = props;

    let history = useHistory();

    const dispatch = useDispatch();
    
    const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const recreateTripForAgentPortal = () =>{
        setLoading(true);
        recreateScheduleCities(scheduleId,()=>{
            updateCreateTrip(scheduleId);
        },(errMsg)=>{
            setLoading(false);
            message.error(errMsg);
        })
    }

    const onSuccessTripCity = (data) =>{
        setLoading(false);
        //    Note : since we are deleting city and stops table data for all cases
        //    we are not need to show confirm popup
            dispatch(setTripData(data));
            dispatch(setTripCityCreated(true));
            history.push({
                pathname:"/trip-create"
            });
    }

    const onFailureTripCity= (err) => {
        message.error(err);
    }


    const updateCreateTrip = (scheduleId) => {
        setLoading(true);
        getScheduleTripCityAction(scheduleId,onSuccessTripCity,onFailureTripCity)
    }
     
   
    return(
        <div>
            <Button onClick={()=> recreationRequired ? recreateTripForAgentPortal() : updateCreateTrip(scheduleId)}>Edit</Button>
        </div>  
    )
}